export const useAuthStore = defineStore("auth", () => {
  const { UNKNOWN, ANONYMOUS, CONNECTED, CONTROLLED } = useAuthStatus;

  // States
  const level = ref(UNKNOWN);

  const provider = ref(null);

  // Getters

  const isUnknown = computed(() => level.value === UNKNOWN);
  const isPublic = computed(() => level.value >= ANONYMOUS);
  const isConnected = computed(() => level.value >= CONNECTED);
  const isControlled = computed(() => level.value === CONTROLLED);

  // Actions

  function set(data) {
    // Auth privilege
    level.value = data.hasControl ? CONNECTED : CONTROLLED;

    // Provider use for auth (email, Google, Facebook or Apple)
    provider.value = data.provider;
  }

  function reset() {
    level.value = ANONYMOUS;
    provider.value = null;
  }

  return {
    provider,
    level,
    isPublic,
    isUnknown,
    isConnected,
    isControlled,
    set,
    reset,
  };
});
